import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { IJumble } from '../jumble.interface';
import { takeUntil } from 'rxjs/operators';
import { JumbleCoreService } from '../jumble-core.service';

@Component({
  selector: 'app-jumble-selector',
  templateUrl: './jumble-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => JumbleSelectorComponent),
    },
  ],
})
export class JumbleSelectorComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private _unsubscribe$ = new Subject<void>();

  @Input()
  hint = '';

  @Output() itemSelected = new EventEmitter<IJumble>();

  ctrl: FormControl = new FormControl();

  constructor(public jumbleCoreService: JumbleCoreService) {}

  ngOnInit(): void {
    this.ctrl.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((value: string) => {
        const jumble = this.jumbleCoreService.getJumbleInfo(value);
        this.itemSelected.emit(jumble);
        if (value) {
          this.onChange(value);
        } else {
          this.onChange(null);
        }
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = (): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouch: any = (): void => {};

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  writeValue(v: string): void {
    this.ctrl.setValue(v);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }

  refresh(): void {
    this.jumbleCoreService.refresh(true);
  }
}
